export interface VerifiedProfileProps {
    memeberImage: string | undefined;
    isVerified: boolean | undefined;
    lastSeenOnline: string | undefined | null;
}

const VerifiedProfile = ({ memeberImage, isVerified, lastSeenOnline }: VerifiedProfileProps) => {

    return (
        <>
            <div className="verified_prof_group">
                {
                    isVerified ? <div className="verified_pict_block">
                        <div className="verified_pict">
                            <img
                                src={memeberImage}
                                loading="lazy"
                                alt=""
                                className="item_pict"
                            />
                        </div>
                        <div className="ic_vi verified" />
                    </div> : null
                }

                <div className="verified_info_group">
                    {
                        isVerified ? <h4 className="verified_info_title">פרופיל מאומת</h4>
                            : null
                    }
                    {lastSeenOnline && <div>ביקור אחרון {lastSeenOnline}</div>}
                </div>
            </div>
        </>

    )

}


export default VerifiedProfile;